import { WidgetSizeT } from "../../../localTypes/WidgetSizeT";

export const weatherWidgetSizes: WidgetSizeT[] = [
  { w: 1, h: 1 },
  { w: 2, h: 1 },
];
